module.exports = __webpack_public_path__ + "img/smg51_samurai01skin_shop.3adaf8ce.png";